function getNextBakeDate() {
  const now = new Date();
  const day = now.getDay(); // 0=dimanche, 1=lundi, 2=mardi...

  function nextDayAtHour(targetDay, hour) {
    const result = new Date(now);
    const diff = (targetDay + 7 - day) % 7;
    result.setDate(now.getDate() + diff);
    result.setHours(hour, 0, 0, 0);
    if (diff === 0 && now > result) result.setDate(result.getDate() + 7);
    return result;
  }

  const nextTuesday8 = nextDayAtHour(2, 8);
  const nextSaturday8 = nextDayAtHour(6, 8);
  return nextTuesday8 < nextSaturday8 ? nextTuesday8 : nextSaturday8;
}

function setCountdownHeightVar() {
  const bar = document.getElementById("cookie-countdown-bar");
  if (!bar) return;
  document.documentElement.style.setProperty("--countdown-h", bar.offsetHeight + "px");
}

function updateCountdown() {
  const target = getNextBakeDate();
  const now = new Date();
  const diff = target - now;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  const el = document.getElementById("cookie-countdown");
  if (!el) return;

  el.innerHTML = `<strong>🔥CUISSON IMMINENTE🔥 - Commandez avant: ${days}j ${hours}h ${minutes}m ${seconds}s</strong>`;

  // si le texte change la hauteur
  setCountdownHeightVar();
}

window.addEventListener("load", () => {
  setCountdownHeightVar();
  updateCountdown();
});

window.addEventListener("resize", setCountdownHeightVar);
setInterval(updateCountdown, 1000);
